/* eslint-disable no-param-reassign */

import createState from "@/store/api/state.js";
import { recursivelyEnhanceMedia } from "@/util/mediaHelper.js";

const mutations = {
  storeCategories(state, categories) {
    state.categories = recursivelyEnhanceMedia(categories);
  },
  removeSubCategory(state, { categoryID, path }) {
    const i = state.category.findIndex(
      (c) => c.path === `/category/${categoryID}`
    );
    const j = state.category[i].categories.findIndex((e) => e.path === path);
    state.category[i].categories.splice(j, 1);
  },
  removeCategory(state, path) {
    const i = state.categories.categories.findIndex((c) => c.path === path);
    if (i > -1) {
      state.categories.categories.splice(i, 1);
    }
    const j = state.category.findIndex((c) => c.path === path);
    if (j > -1) {
      state.category.splice(j, 1);
    }
  },
  removeEntry(state, { categoryID, path }) {
    const i = state.category.findIndex(
      (c) => c.path === `/category/${categoryID}`
    );
    const j = state.category[i].entries.findIndex((e) => e.path === path);
    state.category[i].entries.splice(j, 1);
  },
  // 3 methods below used for bulk DELETE
  removeSubCategories(state, deletions) {
    deletions.forEach(({ path, parentCategoryID }) => {
      const i = state.category.findIndex(
        (c) => c.path === `/category/${parentCategoryID}`
      );
      if (i > -1) {
        const j = state.category[i].categories.findIndex(
          (e) => e.path === path
        );
        if (j > -1) {
          state.category[i].categories.splice(j, 1);
        }
      }
    });
  },
  removeCategories(state, deletions) {
    deletions.forEach(({ path }) => {
      const i = state.categories.categories.findIndex((c) => c.path === path);
      if (i > -1) {
        state.categories.categories.splice(i, 1);
      }
      const j = state.category.findIndex((c) => c.path === path);
      if (j > -1) {
        state.category.splice(j, 1);
      }
    });
  },
  removeEntries(state, deletions) {
    deletions.forEach(({ categoryID, path }) => {
      const i = state.category.findIndex(
        (c) => c.path === `/category/${categoryID}`
      );
      if (i > -1) {
        const j = state.category[i].entries.findIndex((e) => e.path === path);
        if (j > -1) {
          state.category[i].entries.splice(j, 1);
        }
      }
    });
  },
  storeCategory(state, category) {
    const { path } = category;
    const index = state.category.findIndex((c) => c.path === path);
    const cat = recursivelyEnhanceMedia(category);
    if (index > -1) {
      state.category[index] = cat;
    } else {
      state.category.push(cat);
    }
  },
  storeSearchOptions(state, searchOptions) {
    const obj = {};
    obj.data = searchOptions;
    state.searchOptions = obj;
  },
  storeHomeData(state, homeData) {
    state.homeData = recursivelyEnhanceMedia(homeData);
  },
  storeCategoryTree(state, payload) {
    state.categoryTree = payload;
  },
  setCategoriesItem(state, categoriesItem) {
    const index = state.categories.categories.findIndex(
      (c) => c.path === categoriesItem.path
    );
    const item = recursivelyEnhanceMedia(categoriesItem);
    if (index > -1) {
      state.categories.categories[index] = item;
    } else {
      state.categories.categories.push(item);
    }
  },
  storeCalendar(state, { url, data }) {
    const index = state.calendars.findIndex((c) => c.url === url);
    const obj = {
      url,
      data,
    };
    if (index > -1) {
      state.calendars[index] = obj;
    } else {
      state.calendars.push(obj);
    }
  },
  storeMostCommonEntryLayout(state, mostCommonEntryLayout) {
    const obj = { layout: mostCommonEntryLayout };
    state.mostCommonEntryLayout = obj;
  },
  // documentType is either "entry" or "category"
  storeMoveDocumentDestinations(state, { documentType, data }) {
    const docType = documentType === "entry" ? "Entry" : "Category";
    state[`move${docType}Destinations`] = { data };
  },
  storeAllCategories(state, allCategories) {
    state.allCategories = allCategories.map(recursivelyEnhanceMedia);
  },
  resetState(state) {
    const initialState = createState();
    const { homeData } = state;
    state = {
      ...initialState,
      homeData,
    };
  },
  storeRecentlyDeleted(state, recentlyDeleted) {
    state.recentlyDeleted = recentlyDeleted;
  },
  storeAnalytics(state, analytics) {
    state.analytics = analytics;
  },
  storeDatadogAnalytics(state, datadogAnalytics) {
    state.datadogAnalytics = datadogAnalytics;
  },
  storeTwitterFeed(state, tweets) {
    const index = state.twitterFeeds.findIndex(
      (feed) => feed.buttonId === tweets.buttonId
    );
    if (index > -1) {
      state.twitterFeeds[index] = tweets;
    } else {
      state.twitterFeeds.push(tweets);
    }
  },
  storeAllTwitterFeeds(state, feeds) {
    state.twitterFeeds = feeds;
  },
  storeSiteSwitcherSites(state, sites) {
    state.siteSwitcherSites = sites;
  },
};

export default mutations;
